import type { FormInt, Interrogatory } from "@/briefpoint-client";
import styles from "./InterrogatoriesList.module.scss";
import InterrogatoriesListItem from "./InterrogatoriesListItem";

interface InterrogatoriesListProps {
  interrogatories: Interrogatory[];
  selectedInterrogatories: Set<number>;
  documentStartingNumber: number;
  disabled: boolean;
  onToggleSelect: (id: number) => void;
  formIntsMap: Map<string, FormInt> | null;
}

export default function InterrogatoriesList(props: InterrogatoriesListProps) {
  return (
    <div className={styles.interrogatoriesScrollContainer}>
      {props.interrogatories.map((interrogatory) => {
        // For FROGS, look up the FormInt using the interrogatory.text as the ID
        const formInt = props.formIntsMap?.get(interrogatory.text) ?? null;

        return (
          <InterrogatoriesListItem
            key={interrogatory.id}
            interrogatory={interrogatory}
            displayNumber={
              props.documentStartingNumber - 1 + interrogatory.number
            }
            isSelected={props.selectedInterrogatories.has(interrogatory.id)}
            disabled={props.disabled}
            onToggle={() => props.onToggleSelect(interrogatory.id)}
            formInt={formInt}
          />
        );
      })}
    </div>
  );
}
